import React, { useContext, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

const DiscoverSearchContext = React.createContext();

export function useDiscoverSearchAuth() {
  return useContext(DiscoverSearchContext);
}

export function DiscoverSearchProvider({ children }) {
  const [searchValue, setSearchValue] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes('/dashboard/discover')) {
      setSearchValue('');
      setIsSearching(false);
    }
  }, [location]);

  const value = useMemo(() => ({
    searchValue,
    setSearchValue,
    isSearching,
    setIsSearching
  }));

  return <DiscoverSearchContext.Provider value={value}>{children}</DiscoverSearchContext.Provider>;
}

DiscoverSearchProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
